import ConfigProvider from 'antd/lib/config-provider';
export default ConfigProvider;


// WEBPACK FOOTER //
// ./src/components/config-provider/index.tsx